export const shouldResize = (width, height, fileSize, maxWidth, maxHeight, sizeThreshold) => {
    if (maxWidth <= 0 || maxHeight <= 0 || sizeThreshold <= 0)
        return false;
    const overDim = width > maxWidth || height > maxHeight;
    const bigEnough = fileSize > sizeThreshold;
    return overDim && bigEnough;
};
// Calculate dimensions for resizing
export function calculateDimensions(origWidth, origHeight, maxWidth, maxHeight) {
    const ratio = Math.min(maxWidth / origWidth, maxHeight / origHeight, 1);
    return {
        width: Math.round(origWidth * ratio),
        height: Math.round(origHeight * ratio),
    };
}
/**
 * Check if image needs resizing
 * If its overdimension and bigger than the threshold
 * Flag for resizing
 */
export function checkIfResizeNeeded(file, maxWidth, maxHeight, sizeThreshold) {
    return new Promise((resolve) => {
        const img = new Image();
        const url = URL.createObjectURL(file);
        img.onload = () => {
            const resizeNeeded = shouldResize(img.width, img.height, file.size, maxWidth, maxHeight, sizeThreshold);
            URL.revokeObjectURL(url);
            resolve(resizeNeeded);
        };
        img.onerror = () => {
            URL.revokeObjectURL(url);
            resolve(false);
        };
        img.src = url;
    });
}
// Resize image using Canvas API
export function resizeImage(file, maxWidth, maxHeight, quality) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        const url = URL.createObjectURL(file);
        img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            if (!ctx) {
                URL.revokeObjectURL(url);
                reject(new Error("Could not get canvas context"));
                return;
            }
            const { width, height } = calculateDimensions(img.width, img.height, maxWidth, maxHeight);
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);
            canvas.toBlob((blob) => {
                URL.revokeObjectURL(url);
                if (!blob)
                    return reject(new Error("toBlob returned null"));
                const resizedFile = new File([blob], file.name, {
                    type: file.type,
                    lastModified: Date.now(),
                });
                resolve(resizedFile);
            }, file.type, quality);
        };
        img.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error("Image load failed"));
        };
        img.src = url;
    });
}
